import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { SectionHead, CTABand } from "../components/bits";
import { USE_CASES } from "../content/pages";

export default function UseCases() {
  return (
    <>
      <Seo
        path="/use-cases"
        title="Smart Label Use Cases"
        description="Where Bluetooth smart stickers and 4G smart labels earn their keep: pharma cold chain, high-value cargo, and pallet & package tracking."
      />
      <section className="border-b border-border bg-brand-surface">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <h1 className="max-w-3xl text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">Use cases</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">
            Three industries where we see smart labels work — with the honest version of which architecture fits which leg of the journey.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <div className="grid gap-6 md:grid-cols-3">
          {USE_CASES.map((u) => (
            <Link key={u.slug} to={`/use-cases/${u.slug}`} data-testid={`usecase-card-${u.slug}`}
              className="group flex flex-col overflow-hidden rounded-sm border border-border bg-white transition-colors duration-150 hover:border-primary/50">
              <img src={u.images[0].url} alt={u.images[0].alt} loading="lazy"
                className="aspect-[16/10] w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]" />
              <div className="flex flex-1 flex-col p-8">
              <h2 className="text-xl font-semibold text-brand-navy group-hover:text-primary">{u.title}</h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-brand-slate">{u.short}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                Read the use case <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" />
              </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <CTABand title="Don't see your industry?" sub="If it ships, it can probably be tracked. Tell us what moves and where visibility breaks down." />
    </>
  );
}
